<ag-grid-angular
  id="teams-grid"
  domLayout="autoHeight"
  class="ag-theme-quartz"
  [rowData]="flattenedTeamsWithPathInfo"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [treeData]="true"
  [getDataPath]="getDataPath"
  [columnDefs]="colDefs"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
></ag-grid-angular>
